import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Button, Box, Grid, Typography, Pagination, Avatar, Card, CardHeader, Stack } from "@mui/material";
import {
  CLIENT, CLIENTALL
} from "../../services/actions";

import Form from "./Form";
import ActionBar from "../extra/ActionBar";
import companyPng from './company.png'
import { isBase64Image, seedData } from "../../libs/Libs";
import SearchBar from "../extra/SearchBar";
import InfoCard2 from "../extra/InfoCard2";
import XTable from "../extra/XTableAnother";
import MoreInfo from "../extra/MoreInfo";
import MyCard from "../extra/Card"
import NoData from "../extra/NoData";

export default function View() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const PACKAGE = "PACKAGE";
  const [open, setOpen] = React.useState(false);
  const [defV, setDefV] = React.useState({});
  const [view, setView] = React.useState(1);
  const clientState = useSelector((state) => state?.clientState);
  const clientallState = useSelector((state) => state?.clientallState);
  const packageState = useSelector((state) => state?.packageState);
  const user = useSelector((state) => state?.loginState?.auth);

  const [page, setPage] = React.useState(0); // current page  
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchClients = (page = 0) => {
    const url = page === 0 ? `client/${page}/` : `client/?page=${page}`;// pass page number    
    dispatch({ type: `${CLIENT}_GET`, payload: url });
    dispatch({ type: `${CLIENTALL}_GET`, payload: url });
  }


  React.useEffect(() => {
    fetchClients(0)
  }, []);

  React.useEffect(() => {
    fetchClients(page)
  }, [page]);


  // Reload companies when one is added or edited
  React.useEffect(() => {
    console.log("COMAPNY STATUS", clientState)
    if (clientState.success) {
      setOpen(false);
      dispatch({ type: `${CLIENTALL}_GET`, payload: 0 });
    }
  }, [clientState?.data]);

  // Toggle form open with optional default values
  const handleFormOpen = (defaults = {}) => {
    console.log("FOR EDIT", defaults)
    setDefV(defaults);
    // dispatch({ type: `${PACKAGE}_GET`, payload: 0 });
    setOpen(true);
  };


  // Submit new company
  const handleFormSubmit = (payload) => {
    let action = payload?.id ? `${CLIENT}_PATCH` : `${CLIENT}_POST`
    dispatch({ type: action, payload });
  };

  // Handle company delete
  const handleDelete = (id) => {
    dispatch({ type: `${CLIENT}_DELETE`, payload: id });
  };

  // Handle filter search
  const handleSearch = (key, value) => {
    const query = `client/0/?filter_by={"${key}__istartswith":"${value}"}`;
    dispatch({ type: `${CLIENTALL}_GET`, payload: query });
  };

  const tableHeadings = ['id', 'image', 'Company Name', 'Phone', 'Email', 'Project Count', 'Camera Count', 'User Count'];
  const tableRows = clientallState?.data?.results?.map((company) => ({
    id: company.id,
    image: company.image,
    company_name: company.company_name,
    company_phone: company.company_phone,
    company_email: company.company_email,
    project_count: company.project_count,
    camera_count: company.camera_count,
    user_count: company.user_count,
  }));

  return (
    <>
      {open ? (
        <Box sx={{ p: 2 }}>
          <Form
            packages={packageState?.data?.results}
            defaultValues={defV}
            onCancel={() => setOpen(false)}
            onSubmit={handleFormSubmit}
          />
        </Box>
      ) : (
        <Container maxWidth="false" className="py-3">
          <ActionBar
            btnImport={"Import"}
            hasPermission={user?.permissions?.includes("client.add_client")}
            label="Clients"
            btnLabel="ADD CLIENT"
            setOpen={() => handleFormOpen()}
            onBtnClick={(type, col) => {
              if (type === "grid") {
                setView(1);
              }
              if (type === "tabular") {
                setView(2);
              }
              if (type = "import") {
                navigate('/csv/', {
                  state: {
                    data: {},
                    title: "Client", prevNav: '/clients/'
                  }
                })
              }
            }}
            showGrid={[2, 5]}
          />

          <SearchBar bylist={["business_name", "business_entity"]} handleSearch={handleSearch} />

          {view === 1 && (
            <>
              {clientallState?.loading ? (
                <NoData loading={true} loadingTitle="Loading Clients..." loadingMessage="Please wait while we fetch client records." />
              ) : !clientallState?.data?.results || clientallState?.data?.results?.length === 0 ? (
                <NoData title="No Clients Found" message="There are currently no clients to display. Try adjusting your search filters or add a new client." />
              ) : (
                <>
                  <Grid container spacing={1}>
                    {clientallState?.data?.results?.map((company, idx) => {
                      if (!company?.image) {
                        company.image = companyPng
                      }
                      const data = {
                        ...company,
                        no_users: company?.users?.length,
                      };

                      return (

                        <Grid alignItems="stretch" size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }} key={company.id || idx}>
                          <MyCard
                            title={company.business_name}
                            subtitle={company.client_creation_date}
                            onAction={(action) => {
                              if ("more-info" === action) {
                                navigate("/more-info/", {
                                  state: {
                                    data: company,
                                    title: "Client", prevNav: '/clients/'
                                  }
                                })
                              } else if ("edit" === action) {
                                setDefV(company)
                                setOpen(true)
                              } else if ("delete" === action) {
                                handleDelete(company?.id)
                              }

                            }}
                          >
                            <Stack spacing={1.5} sx={{ mt: 1 }}>
                              <Box sx={{ p: 1.5, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #f1f5f9' }}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                  <Typography fontSize={11} color="textSecondary" textTransform="uppercase" letterSpacing={0.5} fontWeight={600}>
                                    Currency
                                  </Typography>
                                  <Typography fontWeight={700} color="#1e293b" fontSize={12}>
                                    {company.currency}
                                  </Typography>
                                </Box>

                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                  <Typography fontSize={11} color="textSecondary" textTransform="uppercase" letterSpacing={0.5} fontWeight={600}>
                                    Business Entity*
                                  </Typography>
                                  <Typography fontWeight={700} color="#3b82f6" fontSize={12}>
                                    {company?.business_entity}
                                  </Typography>
                                </Box>
                              </Box>
                            </Stack>

                          </MyCard>
                        </Grid>
                      );
                    })}
                  </Grid>

                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Pagination
                      count={Math.ceil(clientallState?.data?.count / pageSize)}
                      page={page}
                      onChange={(e, value) => setPage(value)}
                      color="primary"
                    />
                  </Box>
                </>
              )}
            </>
          )}

          {view === 2 && (
            <XTable
              head={tableHeadings}
              rows={tableRows}

              onEdit={(row) => {
                // Find the full company data from the original state using the company name or ID
                const fullCompanyData = clientallState?.data?.results?.find(
                  (company) => company.company_name === row.company_name
                );

                // Add a safety check in case the data is not found
                if (!fullCompanyData) {
                  console.error("Could not find full company data for editing.");
                  return;
                }

                // Perform the data transformation on the full data object
                const redata = {
                  ...fullCompanyData,
                  first_name: fullCompanyData.user.first_name,
                  last_name: fullCompanyData.user.last_name,
                  phone: fullCompanyData.user.phone,
                  user_country_code: fullCompanyData.user.country_code,
                };

                handleFormOpen(redata);
              }}
              onDelete={handleDelete}


            // You can pass action handlers here if you want to make the table interactive
            />
          )}
        </Container>
      )}
    </>
  );
}